<template>
  <form-modal
    :open="isEditModalOpen"
    :heading="$t('modals.expense.edit')"
    entity="expense"
    mode="edit"
    :submit-label="$t('modals.expense.save')"
    :fields="fields"
    :values="expense"
    save-url="/edit-expense.php"
    :build-payload="buildPayload"
    @update:open="$emit('update:isEditModalOpen', $event)"
    @opened="load"
    @saved="() => $emit('expense-edited')"
  />
</template>

<script>
import { ref, computed } from 'vue';
import apiClient from '@/api/apiClient';
import { useSubcategoryOptions } from '@/composables/useSubcategoryOptions';
import FormModal from '@/components/common/FormModal.vue';
import { t } from '@/i18n';

export default {
    components: {
        FormModal,
    },
    props: {
        isEditModalOpen: {
            type: Boolean,
            required: true,
        },
        selectedExpense: {
            type: Object,
            default: () => ({ subcategory_id: null, date: null, note: null, value: null }),
        },
    },
    emits: ['update:isEditModalOpen', 'expense-edited'],
    setup(props) {
        const expense = ref({});
        const { subcategoryGroups, fetchSubcategories } = useSubcategoryOptions();

        const fields = computed(() => [
            { key: 'subcat', label: t('fields.subcategory'), type: 'select', required: true, placeholder: t('placeholders.selectSubcategory'), groups: subcategoryGroups.value },
            { key: 'value', label: t('fields.value'), type: 'number', required: true },
            { key: 'note', label: t('fields.note'), type: 'text' },
            { key: 'date', label: t('fields.date'), type: 'date', required: true },
        ]);

        const buildPayload = (form) => ({
            expenseId: form.id,
            subcat: form.subcat,
            date: form.date,
            note: form.note,
            value: form.value,
        });

        const load = () => {
            expense.value = {};
            fetchSubcategories();
            apiClient.get('/get-expense-details.php?expenseId=' + props.selectedExpense.id)
                .then((response) => {
                    expense.value = {
                        id: parseInt(response.data.id),
                        subcat: parseInt(response.data.subcategory_id),
                        date: response.data.date,
                        note: response.data.note,
                        value: response.data.value,
                    };
                })
                .catch((error) => {
                    console.error('Error fetching expense details:', error);
                });
        };

        return { expense, fields, buildPayload, load };
    },
};
</script>
